import React from "react";
import { Card, CardBody } from "reactstrap";

export default function TotalSpaceCapacity() {
  return (
    <Card className="widget-flat ">
      <CardBody>
        <i className="uil uil-signal-alt-3 float-right" style={{fontSize: '2rem'}}></i>
        <h6 style={{color:'#003247'}} className="text-uppercase mt-0">TOTAL SPACE CAPACITY</h6>
        <h2 className="my-2" id="active-users-count">
          121
        </h2>
      </CardBody>
    </Card>
  );
}
